import {Contact, InvoiceInfo} from "models"
import React, {useRef} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import {Form} from "@kaspernj/api-maker/build/form"
import Heading from "components/utils/heading"
import InputValidator from "shared/input-validator"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import UtilsButton from "components/utils/button"
import UtilsInput from "components/utils/input"
import {View} from "react-native"

/**
 * @typedef {object} ComponentsPlansSignUpModalStepEanInvoiceInfoProps
 * @property {unknown} onEanInvoiceInfoSubmit
 */

/** @typedef {object} ComponentsPlansSignUpModalStepEanInvoiceInfoState */

/**
 * @extends {ShapeComponent<ComponentsPlansSignUpModalStepEanInvoiceInfoProps, ComponentsPlansSignUpModalStepEanInvoiceInfoState>}
 */
class ComponentsPlansSignUpModalStepEanInvoiceInfo extends ShapeComponent {
  static propTypes = {
    onEanInvoiceInfoSubmit: PropTypes.func.isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.plans.sign_up_modal.step_ean_invoice_info"})
    const formRef = useRef()

    this.formRef = formRef
    this.t = t
  }

  render() {
    const {t} = this.tt

    return (
      <View dataSet={this.rootDataSet ||= {component: "plans--sign-up-modal--step-ean-invoice-info"}}>
        <Form formObjectRef={this.tt.formRef}>
          <View style={this.headerWrapStyle ||= {display: "flex", alignItems: "center"}}>
            <Heading>
              {t(".invoice_information")}
            </Heading>
          </View>
          <UtilsInput
            dataSet={this.schoolNameInputDataSet ||= {class: "school-name-input"}}
            label={t(".school_name")}
            name="invoice_info[name]"
            style={this.inputStyle ||= {marginBottom: 15}}
          />
          <UtilsInput
            dataSet={this.eanNumberInputDataSet ||= {class: "ean-number-input"}}
            label={t(".ean_number")}
            name="invoice_info[eanNumber]"
            style={this.inputStyle}
          />
          <UtilsInput
            dataSet={this.noteInputDataSet ||= {class: "note-input"}}
            label={t(".note_or_other")}
            name="invoice_info[note]"
            style={this.inputStyle}
          />
          <UtilsButton
            dataSet={this.submitButtonDataSet ||= {class: "submit-ean-invoice-info-button"}}
            onPress={this.tt.onContinuePressed}
            title={t(".continue")}
          />
        </Form>
      </View>
    )
  }

  onContinuePressed = () => {
    const formData = this.tt.formRef.current.asObject()
    const invoiceInfo = formData.invoice_info || {}

    const inputValidator = new InputValidator({
      inputs: invoiceInfo,
      translations: {
        eanNumber: InvoiceInfo.humanAttributeName("eanNumber"),
        name: Contact.humanAttributeName("name")
      }
    })

    inputValidator
      .validate("eanNumber", {presence: true})
      .validate("name", {presence: true})

    if (inputValidator.isInvalid()) {
      FlashMessage.alert(inputValidator.getErrorMessages().join(" "))
    } else {
      this.p.onEanInvoiceInfoSubmit({invoiceInfo})
    }
  }
}

export default memo(shapeComponent(ComponentsPlansSignUpModalStepEanInvoiceInfo))
